import NavBar from "../../components/Navigation/NavBar";
import PartnersOrbit from "../../components/Parnters/PartnersOrbit";
import BeliefSection from "../../components/Services/BeliefSection";
import CapabilitiesSection from "../../components/Services/CapabilitiesSection";
import CaseStudiesSection from "../../components/Services/CaseStudiesSection";
import ClientLogos from "../../components/Services/ClientLogos";
import ContactSection from "../../components/Services/ContactSection";
import HeroSection from "../../components/Services/HeroSection";
import ShowcaseSection from "../../components/Services/ShowcaseSection";
import Footer from "../../components/Footer/Footer";


export default function NextloopServicesLandingPage() {
    return (
        <>
            <NavBar />
            <HeroSection />
            <PartnersOrbit />
            <BeliefSection />
            <CapabilitiesSection />
            <ShowcaseSection />
            <CaseStudiesSection/>
            <ContactSection/>
            <Footer/>

        </>
    );
}
